import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getAnyPropMailingAddress, getCurrentPropMailingAddress, resetCurrentPropMailingAddress, updateMailingAddress as dispatchUpdateMailling, UpdateMailingPayload } from "../../../redux/actions/mailingAddress/mail";
import { changeIsCloseable, changeModalContent, changeModalState } from "../../../redux/actions/modal/modal";
import { setLargeToast } from "../../../redux/actions/toastNotification/toastNotification";
import { AUTOCOMPLETE, CURRENT_ANY_PROP_MAILING_ADDRESS, CURRENT_PROP_MAILING_ADDRESS, UPDATE_PROP_MAILING_ADDRESS } from "../../../redux/actionTypes/actionsTypes";
import { AutoCompleteItem } from "../../../redux/reducers/getNBHDReducer/getAutoCompleteReducer";
import { MailingAddressDetails } from "../../../redux/reducers/getPropMailingAddressReducer/mailingAddress";
import { RootState } from "../../../redux/reducers/root";
import extractFormData from "../../../utils/extractFormData";
import massageJson from "../../../utils/massageJson";
import AmpAddressSearch from "../../common/AmpAddressSearch/AmpAddressSearch";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import AmpInput from "../../common/AmpInput/AmpInput";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import AmpPhoneNumber from "../../common/AmpPhoneNumber/AmpPhoneNumber";
import AppSmallHeading from "../../common/AmpSmallHeading/AppSmallHeading";
import AttestationMailingAddress from "./Attestation";
import "./MailingAddress.css";
import Submissions from "./Submissions";

const initialForm: MailingAddressDetails = {
    roll: "",
    unit: "",
    city: "",
    addr: "",
    postal_code: "",
    province: "",
    email: "",
    user_profile_id: "",
    submission_id: "",
    submission_date: 0,
    phone: "",
    status: ""
}

export default function MailingAddress() {
    const { t } = useTranslation(["property", "login"]);
    const [isEditable, setIsEditable] = useState(false);
    const [formValues, setFormValues] = useState<MailingAddressDetails>(initialForm);
    const [requestSent, setRequestSent] = useState(false);
    const [submissionSent, setSubmissionSent] = useState(false);
    const [formNotfilled, setFormNotFilled] = useState(false);

    const currentRoll = window.localStorage.getItem("currentProperty");

    const dispatch = useDispatch();

    const mailingAddressCurrentProp = useSelector((state: RootState) => state.mailingAddressRoot?.mailingAddress);
    const mailingAddressAnyProp = useSelector((state: RootState) => state.mailingAddressRoot?.mailingAddressAny);
    const updateMailingAddress = useSelector((state: RootState) => state.mailingAddressRoot?.updateMailingAddress);

    const prePopEditLoading = mailingAddressAnyProp.loading;

    useEffect(() => {
        if (mailingAddressCurrentProp.address_data && !formValues.addr && !mailingAddressCurrentProp.loading && !isEditable && !requestSent) {
            dispatch(resetCurrentPropMailingAddress())
            dispatch(getCurrentPropMailingAddress(currentRoll as string));
            setRequestSent(true);
        }
    }, [mailingAddressCurrentProp.address_data, mailingAddressCurrentProp.loading, formValues.addr, isEditable, requestSent, dispatch, currentRoll])

    useEffect(() => {
        if (!mailingAddressCurrentProp.loading && !requestSent && !mailingAddressCurrentProp.address_data) {
            dispatch(getCurrentPropMailingAddress(currentRoll as string));
            setRequestSent(true);
        } else if (requestSent && !mailingAddressCurrentProp.loading && !mailingAddressCurrentProp.found) {
            // set an error
            console.log("asdasds");

         } //else if (requestSent && !mailingAddressCurrentProp.loading && mailingAddressCurrentProp.found && mailingAddressCurrentProp.address_data) {
        //     const data = mailingAddressCurrentProp.address_data;
        //     const email = localStorage.getItem("email");
        //     data["email"] = email as string;

        //     // setFormValues(massageJson(data) as MailingAddressDetails)
        // }
    }, [mailingAddressCurrentProp, currentRoll, dispatch, requestSent]);

    useEffect(() => {
        if (!mailingAddressAnyProp.loading && mailingAddressAnyProp.found && mailingAddressAnyProp.address_data) {
            setFormValues(mailingAddressAnyProp.address_data as MailingAddressDetails)
        }
    }, [mailingAddressAnyProp]);

    useEffect(() => {
        // Happy Path submission sucsessful
        if (submissionSent && updateMailingAddress.submitted && !updateMailingAddress.loading) {
            // dispatch(setToastNotification(t("mailing.submission-success-toast"), "success"));
            dispatch(setLargeToast(t("mailing.submission-success-large"), "success", true));
            setSubmissionSent(false);
            setIsEditable(false);
            dispatch(getCurrentPropMailingAddress(currentRoll as string));
            setRequestSent(true);
            // // Error paths
        }

    }, [updateMailingAddress, currentRoll, dispatch, submissionSent, t])

    const onEdit = (e: FormEvent) => {
        // clear form
        // enable submit
        // disable edit
        e.preventDefault();
        const data = initialForm;
        const email = localStorage.getItem("email");
        data["email"] = email as string;
        setFormValues(initialForm)
        setIsEditable(true);
        dispatch({ type: AUTOCOMPLETE.RESET })
        return
    }

    const checkFormFields = (data: Record<string, unknown>) => {
        const requiredFields = ["addr", "postal_code", "city", "province"]
        for (const [key, value] of Object.entries(data)) {
            if (value === "" && requiredFields.includes(key)) {
                return false
            }
        }
        return true;
    }

    const onFormSubmit = (e) => {
        setLargeToast("", "success", false)
        // Show Attestation Modal
        e.preventDefault()
        const submission = extractFormData(e);
        const checks = checkFormFields(submission);
        if (!checks) {
            setFormNotFilled(true);
            return;
        }

        dispatch(changeIsCloseable(false));
        dispatch(changeModalContent(
            <AttestationMailingAddress callback={(data) => onAttestationSubmit(data)} submissionData={submission} />,
            "Attestation",
            "ariaLabelText"));

        dispatch(changeModalState("modal-fade-in"));
        return
    }

    const onAttestationSubmit = (data: Record<string, unknown>) => {
        dispatch(changeModalState("modal-fade-out"));
        dispatch(changeModalContent());
        dispatch({ type: CURRENT_PROP_MAILING_ADDRESS.RESET });
        dispatch({ type: UPDATE_PROP_MAILING_ADDRESS.RESET });
        dispatch({ type: CURRENT_ANY_PROP_MAILING_ADDRESS.RESET });
        const email = localStorage.getItem("email");
        data["roll"] = currentRoll;
        data["email"] = email;
        data["phone"] = `${data["phone"]}${data["phone-ext"]}`
        delete data["phone-ext"]
        dispatch(dispatchUpdateMailling(data as UpdateMailingPayload));
        setSubmissionSent(true);
        console.log(data);
        return
    }

    const onCancel = () => {
        setFormValues(initialForm)
        setIsEditable(false);
        setFormNotFilled(false);
        dispatch(resetCurrentPropMailingAddress())
        dispatch(getCurrentPropMailingAddress(currentRoll as string));
        setRequestSent(true);
        return
    }

    const showSubmission = (submission: MailingAddressDetails) => {
        setFormValues(massageJson(submission) as MailingAddressDetails);
    }

    const onAutoCompleteSelect = (item: AutoCompleteItem) => {
        console.log(item);
        dispatch(getAnyPropMailingAddress(item.roll as string));
    }

    return (
        <div className="mailing-root">
            <div className="mailing-information">
                <div className="mailing-info-icon">
                    <FontAwesomeIcon icon={faInfoCircle} size={"3x"} />
                </div>

                <div className="mailing-info-content">
                    <p>
                        {t("mailing.info1")}
                    </p>
                    <p>
                        {t("mailing.info2")}
                    </p>
                </div>
            </div>

            <div className="mailing-top">
                <AmpLoadingSpinner loading={mailingAddressCurrentProp.loading || updateMailingAddress.loading}>
                    <form className="mailing-address-content" onSubmit={(e) => onFormSubmit(e)} autoComplete="off">
                        <div className={`title-row ${isEditable && "warn"}`}>
                            {isEditable && t("mailing.edit-title")}
                            {!isEditable && t("mailing.current-title")}
                        </div>
                        <div className="form-content">
                            <AppSmallHeading required={true} for={"address"}>{t("mailing.heading-1")}</AppSmallHeading>
                            {isEditable && <AmpAddressSearch
                                type={""}
                                city={""}
                                id={"address"}
                                name={"addr"}
                                className={""}
                                placeholder={""}
                                onAutoCompleteSelect={(item) => onAutoCompleteSelect(item)}
                            />}
                            {!isEditable && <AmpInput name="addr" id="address" type={"text"} readOnly={!isEditable} value={formValues.addr} />}
                            <AppSmallHeading for={"unit"}>{t("mailing.heading-2")}</AppSmallHeading>
                            <AmpInput loading={prePopEditLoading} name="unit" id="unit" type={"text"} readOnly={!isEditable} value={formValues.unit} />
                            <AppSmallHeading required={true} for={"city"}>{t("mailing.heading-3")}</AppSmallHeading>
                            <AmpInput loading={prePopEditLoading} name="city" id="city" type={"text"} readOnly={!isEditable} value={formValues.city} />
                            <div className="row">
                                <div>
                                    <AppSmallHeading required={true} for={"postal_code"}>{t("mailing.heading-4")}</AppSmallHeading>
                                    <AmpInput loading={prePopEditLoading} name="postal_code" id="postal_code" type={"text"} readOnly={!isEditable} value={formValues.postal_code} />
                                </div>
                                <div>
                                    <AppSmallHeading required={true} for={"province"}>{t("mailing.heading-5")}</AppSmallHeading>
                                    <AmpInput loading={prePopEditLoading} name="province" id="province" type={"text"} readOnly={!isEditable} value={formValues.province} />
                                </div>
                            </div>
                            <div className={`row`}>
                                <AppSmallHeading for={"phone"} centered={true}>{t("mailing.heading-phone")}</AppSmallHeading>
                                <AmpPhoneNumber name={"phone"} id={"phone"} phoneNumber={formValues.phone as string} readOnly={!isEditable}/>
                            </div>

                            <div className={`row`}>
                                <AppSmallHeading for={"email"} centered={true}>{t("mailing.heading-6")}</AppSmallHeading>
                                <AmpInput name="email" id="email" type={"text"} readOnly={true} value={formValues.email} disabled />
                            </div>


                            <AmpFormError errorMessage={"Error Occured saving your submission"} error={updateMailingAddress.db_error} />
                            <AmpFormError errorMessage={"Error Occured posting your submission"} error={updateMailingAddress.mq_error} />
                            <AmpFormError errorMessage={t("mailing.required-fields")} error={formNotfilled} />

                        </div>
                        <div className="form-actions">
                            <Link rel="noreferrer noopener" target="_blank" className="amp-anchor" to="/amp/contact-us">{t("need-help", {
                                "ns": "login"
                            }) as string}</Link>
                            <div>

                                <AmpButton
                                    onClick={(e) => onEdit(e)} type={"cancel"} text={t("mailing.edit")} disabled={isEditable} />
                                {isEditable &&
                                    <>
                                        <AmpButton
                                            onClick={() => onCancel()} type={"cancel"} text={t("cancel", { "ns": "login" })} />
                                        <AmpButton
                                            onClick={() => null}
                                            type={"submit"}
                                            text={t("submit", { "ns": "login" })}
                                            disabled={!isEditable} />
                                    </>}
                            </div>

                        </div>
                    </form>
                </AmpLoadingSpinner>
                <Submissions isEdit={isEditable} onSelect={(submission) => showSubmission(submission)} />
            </div>
        </div>

    )
}